<script>
    export let tooltipLines = [];
</script>

<style>
    :global(.tooltip.tooltip-theme) {
        --tooltip-padding: 5px;
        --tooltip-font-size: 14px ;
        --tooltip-font-weight: 400;
        --tooltip-line-height: 1.5;
        --tooltip-z-index:1036;
        width: max-content;
    }
</style>

{#each tooltipLines as line}
    {line} <br/>
{/each}


